import { cn } from "@repo/blacksmith-ui/cn";

export function VercelTriangle({ className }: { className?: string }) {
  return (
    // The triangle's mass sits in its lower third, so box-centering reads as
    // sunk beside a label. The lift is a share of the icon so it holds at
    // every size the button renders it at.
    <svg
      viewBox="0 0 76 65"
      fill="currentColor"
      className={cn("-translate-y-[7.5%]", className)}
    >
      <path d="M37.59.25l36.95 64H.64l36.95-64z" />
    </svg>
  );
}
